export function attached(container: HTMLElement, node: HTMLElement, timeout = 20000) {
  return new Promise<void>((resolve, reject) => {
    let af: number;
    if (container.contains(node)) {
      resolve();
    } else {
      const observer = new MutationObserver((mutationList, observer) => {
        if (af) {
          return;
        }
        af = requestAnimationFrame(() => {
          af = undefined;
          if (container.contains(node)) {
            observer.disconnect();
            resolve();
          }
        })
      });
      observer.observe(container, {
        childList: true,
        subtree: true
      });

      if (timeout > 0) {
        setTimeout(() => {
          observer.disconnect();
          reject();
        }, timeout);
      }
    }
  });
}